import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../axios";

export const fetchLeads = createAsyncThunk("leads/fetchLeads", async () => {
    const { data } = await axios.get("/leads");
    return data;
});

export const fetchRemoveLead = createAsyncThunk("leads/fetchRemoveLead", async (id) => {
    axios.delete(`/leads/${id}`);
});

const initialState = {
    leads: {
        items: [],
        status: "loading",
    },
};

const leadsSlice = createSlice({
    name: "leads",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLeads.pending, (state) => {
                state.leads.items = [];
                state.leads.status = "loading";
            })
            .addCase(fetchLeads.fulfilled, (state, action) => {
                state.leads.items = action.payload;
                state.leads.status = "loaded";
            })
            .addCase(fetchLeads.rejected, (state) => {
                state.leads.items = [];
                state.leads.status = "error";
            })
            .addCase(fetchRemoveLead.pending, (state, action) => {
                state.leads.items = state.leads.items.filter(
                    (obj) => obj._id !== action.meta.arg
                );
            });
    },
});

export const leadsReducer = leadsSlice.reducer;
